import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

import { userGeneralPreferencesList } from '../slice'
import { loadGeneralPreferences } from '../api'

export const useLoadGeneralPreferencesOnMount = (authenticated: boolean) => {
  const dispatch = useAppDispatch()
  const userGeneralPreferences = useSelector(userGeneralPreferencesList)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let mounted = true
    const execute = async () => {
      try {
        setLoading(true)
        await dispatch(loadGeneralPreferences())

        if (mounted) {
          setLoading(false)
        }
      } catch {
        if (mounted) {
          setLoading(false)
        }
      }
    }

    authenticated ? execute() : setLoading(false)

    return () => {
      mounted = false
    }
  }, [dispatch, authenticated])

  return { loading, userGeneralPreferences }
}
